'use client';

import { ISbStoryData, useStoryblokState } from '@storyblok/react';
import { FC, PropsWithChildren, ReactNode } from 'react';
import { getStoryblokApi } from 'commerce/storyblok/instanceSSR';

export default function StoryblokProvider({
  children,
}: {
  children: ReactNode;
}) {
  getStoryblokApi();

  return children;
}

interface IProps extends PropsWithChildren {
  story: ISbStoryData;
}

/**
 * This is fix for storyblok visual live editing. Without this state
 * edition doesn't work
 */
export const StoryBlokLiveEditState: FC<IProps> = ({ story, children }) => {
  useStoryblokState(story);

  return <>{children}</>;
};
